// import { Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getPatientPainListData } from "../../service/api.service";
import PainSensitivity from "./PainSensitivity";
import PainSensitivityResult from "./PainSensitivityResult";
function PainSensitivityTab(props) {
    const [value, setValue] = useState(1);
    const [patientPainData, setPatientPainData] = useState();
    let location = useLocation();
    const handleChangeTabs = (ev) => {
        setTimeout(() => {
            setValue(ev)
        }, 200);

    }
    const getPatientListData = () => {
        getPatientPainListData(location.state.id, resp => {
            if (resp) {
                if (resp.error) {
                    setPatientPainData({});
                } else {
                    setValue(0)
                    setPatientPainData(resp);
                }
            } else {

                setPatientPainData({});
            }
        })
    }

    useEffect(() => {
        if (!patientPainData) {
            getPatientListData()
        }
    });
    
    return (
        <div className="realtive p-4 mt-14">
            <Box
                sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
            >

                {
                    value === 1 &&
                    < PainSensitivity value={props.value} patientAnalysis={props.patientAnalysis} state={props.state} parentCallbackToTabs={handleChangeTabs}>
                    </PainSensitivity>
                }
                {
                    value === 0 &&
                    <PainSensitivityResult value={props.value} patientAnalysis={props.patientAnalysis} state={props.state} parentCallbackToTabs={handleChangeTabs}>
                    </PainSensitivityResult>
                }

            </Box>
        </div>
    )
}
export default PainSensitivityTab;